import React from "react";
import { useTranslation } from "react-i18next";
import { typeByVibroLevel, vibroTextByLevel } from "../../../common/consts";
import CusButton from "../../../mui/CusButton";
import { useAppSelector } from "../../../../store/index.ts";

export default function LovenseTip({ tip, onTipItem, chooseBtn, onBtnClick }) {
  const { t } = useTranslation();
  const balance = useAppSelector((state) => state.user.user.balance);

  const type = typeByVibroLevel[tip.vLevel];
  const vibro = vibroTextByLevel[tip.vLevel];
  const isBtn = chooseBtn === tip.id;

  const minToken = tip.token || tip.min;
  const max = tip.token || tip.max;
  const maxToken = max == "infinity" ? 999 : max;

  const sendText = tip.token ? `${t("Send")} ${tip.token} ${t("tk")}` : `${"Send"} ${maxToken}`;

  return (
    <div className="chat__tips__item toys" onClick={() => onTipItem(tip)}>
      <span className="chat__tips__item__actmty">
        {t(tip.time)} {t("sec.")}
      </span>
      <span className={`chat__tips__item__vibro ${type}`}>{t(vibro)}</span>

      <span className="chat__tips__item__tokens">
        {isBtn ? (
          <CusButton
            color="red"
            text={balance < minToken ? "Buy tokens" : sendText}
            onClick={(e) => onBtnClick(e, tip)}
          />
        ) : (
          <>
            {tip.min} ~ {tip.max}
          </>
        )}
      </span>
    </div>
  );
}
